import { Address } from 'viem'

// Contract addresses (to be updated after deployment)
export const NODE_REGISTRY_ADDRESSES = {
  1: import.meta.env.VITE_ETHEREUM_CONTRACT_ADDRESS as Address, // Ethereum mainnet
  // 8453: import.meta.env.VITE_BASE_CONTRACT_ADDRESS as Address, // Base mainnet
  // 480: import.meta.env.VITE_WORLDCHAIN_CONTRACT_ADDRESS as Address, // World Chain
  11155111: import.meta.env.VITE_SEPOLIA_CONTRACT_ADDRESS as Address, // Sepolia testnet
  // 84532: import.meta.env.VITE_BASE_SEPOLIA_CONTRACT_ADDRESS as Address, // Base Sepolia testnet
  // 4801: import.meta.env.VITE_WORLDCHAIN_SEPOLIA_CONTRACT_ADDRESS as Address, // World Chain Sepolia testnet
  // 31337: import.meta.env.VITE_LOCALHOST_CONTRACT_ADDRESS as Address, // Localhost/Hardhat
} as const

export const SUPPORTED_CHAINS = [1, 11155111] as const

export type SupportedChainId = typeof SUPPORTED_CHAINS[number]

// Contract ABI (simplified for the functions we need)
export const NODE_REGISTRY_ABI = [
  {
    name: 'nodeOf',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ name: '', type: 'string' }],
  },
  {
    name: 'getNode',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ name: '', type: 'string' }],
  },
  {
    name: 'hasNode',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ name: '', type: 'bool' }],
  },
  {
    name: 'setNode',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [{ name: 'newNode', type: 'string' }],
    outputs: [],
  },
  {
    name: 'MAX_NODE_LENGTH',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'uint256' }],
  },
  {
    name: 'version',
    type: 'function',
    stateMutability: 'pure',
    inputs: [],
    outputs: [{ name: '', type: 'string' }],
  },
  {
    type: 'event',
    name: 'NodeUpdated',
    inputs: [
      { name: 'owner', type: 'address', indexed: true },
      { name: 'node', type: 'string', indexed: false },
    ],
  },
] as const

// Chain configuration
export const CHAIN_CONFIG = {
  1: {
    name: 'Ethereum',
    shortName: 'ETH',
    blockExplorer: 'https://etherscan.io',
    color: '#627eea',
    icon: '⟠',
  },
  11155111: {
    name: 'Sepolia',
    shortName: 'SEP',
    blockExplorer: 'https://sepolia.etherscan.io',
    color: '#ffc107',
    icon: '🧪',
  },

} as const

// Validation constants
export const MAX_NODE_LENGTH = 64
export const NODE_ADDRESS_PATTERN = /^(https?:\/\/|wss?:\/\/)?[\w.-]+(:\d+)?(\/.*)?$/

// Common node address examples
export const NODE_EXAMPLES = [
  'https://node.example.com',
  'http://192.168.1.100:8080',
  'wss://secure.node.com:443',
  'node.local:8545',
] as const
